<div class="layout">
  <nav class="navbar">
    <div class="navbar-left">
      <img src="../../../assets/icon-vendeur-blanc-01.png" alt="Logo" class="logo1" />
      <img src="../../../assets/Vendeur-site-small-version.png" alt="Logo" class="logo2" />
    </div>
  </nav>

  <div class="content-wrapper">
    <div class="wizard" *ngIf="!loading(); else loadingTpl">
      <!-- Stepper -->
      <aside class="stepper">
        <h3 class="stepper-title">Votre inscription</h3>
        <ul>
          <li
            *ngFor="let key of STEP_ORDER"
            class="step"
            [class.active]="activeStep() === key"
            [class.done]="stepStatus(key) === 'done'"
            (click)="goTo(key)"
          >
            <span class="dot">
              <span class="material-icons-outlined" *ngIf="stepStatus(key) === 'done'">check</span>
              <span *ngIf="stepStatus(key) !== 'done'">{{ STEP_ORDER.indexOf(key) + 1 }}</span>
            </span>
            <span class="step-label">
              {{
                key === 'email' ? 'E-mail' :
                key === 'phone' ? 'Téléphone' :
                key === 'profile' ? 'Profil' :
                key === 'contract' ? 'Contrat' : 'Validation'
              }}
              <em class="badge" *ngIf="key === 'review' && unread() > 0">{{ unread() }}</em>
            </span>
          </li>
        </ul>
      </aside>

      <!-- Panneau de l'étape active -->
      <main class="panel">
        <!-- E-MAIL -->
        <section *ngIf="activeStep() === 'email'">
          <h2>Vérifiez votre e-mail</h2>
          <ng-container *ngIf="stepStatus('email') === 'done'; else emailTodo">
            <p class="ok-line"><span class="material-icons-outlined">verified</span> Votre e-mail est vérifié.</p>
            <button class="btn primary" (click)="goTo('phone')">Continuer</button>
          </ng-container>
          <ng-template #emailTodo>
            <p>Nous avons envoyé un lien de confirmation à <strong>{{ state()?.email }}</strong>.</p>
            <p class="muted">Cliquez sur le lien reçu, puis revenez ici.</p>
            <div class="row">
              <button class="btn ghost" (click)="resendEmail()" [disabled]="emailResending()">
                {{ emailResending() ? 'Envoi…' : "Renvoyer l'e-mail" }}
              </button>
              <button class="btn" (click)="refresh()">J'ai vérifié</button>
            </div>
          </ng-template>
        </section>

        <!-- TÉLÉPHONE -->
        <section *ngIf="activeStep() === 'phone'">
          <h2>Vérifiez votre téléphone</h2>
          <ng-container *ngIf="stepStatus('phone') === 'done'; else phoneTodo">
            <p class="ok-line"><span class="material-icons-outlined">verified</span> Votre numéro est vérifié.</p>
            <button class="btn primary" (click)="goTo('profile')">Continuer</button>
          </ng-container>
          <ng-template #phoneTodo>
            <p class="muted">Recevez un code par WhatsApp pour valider votre numéro.</p>
            <div class="form-group">
              <label>Numéro de téléphone (format international)</label>
              <input
                type="tel"
                placeholder="+216..."
                [ngModel]="otpPhone()"
                (ngModelChange)="otpPhone.set($event)"
              />
            </div>
            <button class="btn ghost" (click)="sendOtp()" [disabled]="otpSending()">
              {{ otpSending() ? 'Envoi…' : (otpSent() ? 'Renvoyer le code' : 'Envoyer le code') }}
            </button>

            <div class="form-group" *ngIf="otpSent()">
              <label>Code reçu</label>
              <input
                type="text"
                inputmode="numeric"
                placeholder="123456"
                [ngModel]="otpCode()"
                (ngModelChange)="otpCode.set($event)"
              />
            </div>
            <button class="btn primary" *ngIf="otpSent()" (click)="verifyOtp()" [disabled]="otpVerifying()">
              {{ otpVerifying() ? 'Vérification…' : 'Valider le code' }}
            </button>
          </ng-template>
        </section>

        <!-- PROFIL -->
        <section *ngIf="activeStep() === 'profile'">
          <h2>Complétez votre profil</h2>
          <ng-container *ngIf="stepStatus('profile') === 'done'">
            <p class="ok-line"><span class="material-icons-outlined">verified</span> Profil complété. Vous pouvez le mettre à jour ci-dessous.</p>
          </ng-container>

          <div class="form-group">
            <label>Type d'utilisateur</label>
            <select [(ngModel)]="user.user_type">
              <option value="individual">Individuel</option>
              <option value="company">Entreprise</option>
            </select>
          </div>
          <div class="form-group" *ngIf="user.user_type === 'company'">
            <label>Nom de l'entreprise</label>
            <input type="text" [(ngModel)]="user.company_name" placeholder="Nom de l'entreprise" />
          </div>
          <div class="form-group" *ngIf="user.user_type === 'individual'">
            <label>Nom du magasin</label>
            <input type="text" [(ngModel)]="user.store_name" placeholder="Nom du magasin" />
          </div>
          <div class="form-group" *ngIf="user.user_type === 'individual'">
            <label>Catégories de vente</label>
            <input type="text" [(ngModel)]="user.categories" placeholder="Séparées par des virgules" />
          </div>
          <div class="form-group">
            <label>Numéro de téléphone</label>
            <input type="tel" [(ngModel)]="user.mobile" placeholder="Téléphone (facultatif)" />
          </div>
          <div class="form-group">
            <vd-address-picker
              label="Adresse de votre boutique"
              placeholder="Tapez l'adresse, utilisez le GPS ou cliquez sur la carte"
              defaultCountry="tn"
              [value]="addressValue()"
              [compact]="false"
              (valueChange)="onAddressChange($event)"
            ></vd-address-picker>
          </div>
          <div class="form-group">
            <label>Adresse 2 (facultatif)</label>
            <input type="text" [(ngModel)]="user.address2" placeholder="Complément, étage, bureau…" />
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea [(ngModel)]="user.description" placeholder="Décrivez-vous ou votre entreprise"></textarea>
          </div>

          <button class="btn primary" (click)="saveProfile()" [disabled]="profileSaving()">
            {{ profileSaving() ? 'Enregistrement…' : 'Enregistrer et continuer' }}
          </button>
        </section>

        <!-- CONTRAT -->
        <section *ngIf="activeStep() === 'contract'">
          <h2>Signez les conditions vendeur</h2>
          <ng-container *ngIf="stepStatus('contract') === 'done'; else contractTodo">
            <p class="ok-line"><span class="material-icons-outlined">verified</span> Vos CGU vendeur sont signées.</p>
            <button class="btn primary" (click)="goTo('review')">Continuer</button>
          </ng-container>
          <ng-template #contractTodo>
            <p class="muted">
              Signature électronique des conditions générales d'utilisation vendeur,
              par code reçu par e-mail<span *ngIf="state()?.email"> à {{ state()?.email }}</span>.
            </p>

            <!-- Étape 1 : recevoir le code -->
            <button
              *ngIf="!contractOtpSent()"
              class="btn primary"
              (click)="sendContractOtp()"
              [disabled]="contractOtpSending()"
            >
              {{ contractOtpSending() ? 'Envoi du code…' : 'Recevoir le code de signature' }}
            </button>

            <!-- Étape 2 : saisir le code + signer -->
            <ng-container *ngIf="contractOtpSent()">
              <div class="form-group">
                <label>Code reçu par e-mail</label>
                <input
                  type="text"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  placeholder="123456"
                  [ngModel]="contractOtpCode()"
                  (ngModelChange)="contractOtpCode.set($event)"
                />
              </div>
              <p class="muted small" *ngIf="contractSimOtp()">
                Mode test — code : <strong>{{ contractSimOtp() }}</strong>
              </p>
              <div class="row">
                <button class="btn ghost" (click)="sendContractOtp()" [disabled]="contractOtpSending()">
                  {{ contractOtpSending() ? 'Envoi…' : 'Renvoyer le code' }}
                </button>
                <button class="btn primary" (click)="verifyContract()" [disabled]="contractSigning()">
                  {{ contractSigning() ? 'Signature…' : 'Signer le contrat' }}
                </button>
              </div>
            </ng-container>
          </ng-template>
        </section>

        <!-- VALIDATION + DISCUSSION -->
        <section *ngIf="activeStep() === 'review'">
          <ng-container *ngIf="isApproved()">
            <div class="status ok">
              <span class="material-icons-outlined">celebration</span>
              <div>
                <h2>Compte validé !</h2>
                <p>Votre compte vendeur est approuvé. Vous pouvez publier vos produits et vendre.</p>
              </div>
            </div>
            <button class="btn primary" (click)="goToDashboard()">Aller à mon tableau de bord</button>
          </ng-container>

          <ng-container *ngIf="!isApproved()">
            <ng-container *ngIf="isPending()">
              <div class="status pending">
                <span class="material-icons-outlined">hourglass_top</span>
                <div>
                  <h2>Dossier en cours de validation</h2>
                  <p>Notre équipe examine votre dossier. Suivez l'échange ci-dessous.</p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="isRejected()">
              <div class="status rejected">
                <span class="material-icons-outlined">report</span>
                <div>
                  <h2>Dossier à revoir</h2>
                  <p *ngIf="state()?.approval_note">{{ state()?.approval_note }}</p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!isPending() && !isRejected()">
              <h2>Finalisez votre inscription</h2>
              <p class="muted" *ngIf="state()?.prerequisites_done">
                Toutes les étapes sont complétées. Soumettez votre dossier pour validation.
              </p>
              <p class="muted" *ngIf="!state()?.prerequisites_done">
                Terminez les étapes précédentes pour pouvoir soumettre votre dossier.
              </p>
              <button
                class="btn primary"
                (click)="submit()"
                [disabled]="submitting() || !state()?.prerequisites_done"
              >
                {{ submitting() ? 'Envoi…' : 'Soumettre pour validation' }}
              </button>
            </ng-container>

            <!-- Discussion avec l'équipe support -->
            <div class="chat">
              <h3>Échange avec l'équipe vendeur.site</h3>
              <div class="thread">
                <div class="muted small" *ngIf="messages().length === 0">
                  Aucun message pour le moment. Posez votre question ci-dessous.
                </div>
                <div
                  *ngFor="let m of messages(); trackBy: trackByMsg"
                  class="msg"
                  [class.support]="isSupport(m)"
                >
                  <div class="msg-meta">{{ isSupport(m) ? 'Support vendeur.site' : 'Vous' }}</div>
                  <div class="msg-body">{{ m.body }}</div>
                </div>
              </div>
              <div class="composer">
                <textarea
                  rows="2"
                  placeholder="Écrire un message à l'équipe support…"
                  [ngModel]="draftMessage()"
                  (ngModelChange)="draftMessage.set($event)"
                ></textarea>
                <button class="btn primary" (click)="sendMessage()" [disabled]="sendingMsg()">
                  <span class="material-icons-outlined">send</span>
                </button>
              </div>
            </div>
          </ng-container>
        </section>
      </main>
    </div>

    <ng-template #loadingTpl>
      <div class="loading">Chargement de votre progression…</div>
    </ng-template>
  </div>
</div>
